export const yieldToMain = () => {
    return new Promise(resolve => {
        window.setTimeout(resolve, 0);
    });
};
